import API_PUBLIC_SERVICE, { SERVER_API, publicInstance } from './http';

const PREFIX = 'address';

const tableData = {
  tableName: '',
  tableHeader: [],
  hasCheckbox: false
};

const makeNormalizationData = (commune, address, number, extra) => {
  return {
    commune,
    address,
    number,
    extra
  };
};

const normalization = async json => {
  const namePrefix = 'address-normalization';

  try {
    const res = await publicInstance.post(`${SERVER_API}${namePrefix}`, json);
    let { data } = await res;
    return data;
  } catch (err) {
    throw err;
  }
};

const AddressService = {
  path: PREFIX,
  ...API_PUBLIC_SERVICE,
  ...tableData,
  makeNormalizationData,
  normalization
};

export default AddressService;
